import { Component, Input, OnInit } from '@angular/core';
import { HelpDocumentService } from '../../service/help-document.service';
import { DocumentService } from '../../service/document.service';
import { saveAs } from '@progress/kendo-file-saver';
import { sortBy } from 'lodash';

@Component({
  standalone: false,
  selector: 'app-help-documents',
  templateUrl: './help-documents.component.html',
  styleUrls: ['./help-documents.component.scss']
})
export class HelpDocumentsComponent implements OnInit
{
  @Input() public language: string;

  public loading = true;
  public helpDocuments = [];

  constructor(
    private helpDocumentService: HelpDocumentService,
    private documentService: DocumentService) { }

  public ngOnInit(): void
  {
    this.helpDocumentService.getHelpDocumentList(true).subscribe({
      next: (helpDocuments) =>
      {
        helpDocuments = sortBy(helpDocuments, ['name']);
        helpDocuments.forEach((document: any) =>
        {
          this.documentService.getFileTypeClass(document.mimeType);
        });
        this.helpDocuments = helpDocuments;
        this.loading = false;
      }
    });
  }

  /**
   * Download the import items for a batch
   *
   * @param url Document reference url to download
   * @param name Docuement name
   */
  public saveFileLocal(url: string, name: string): void
  {
    this.documentService.retrieveDocument(url).subscribe({
      next: (data) =>
      {
        saveAs(`data:${data.mimeType};base64,${data.content}`, name);
      }
    });
  }

  /**
   * Return the proper class to used based on the file mime type.
   *
   * @param mimeType Mime Type of the file.
   * @returns String
   */
  public getFileTypeClass(mimeType: string): string
  {
    return this.documentService.getFileTypeClass(mimeType);
  }

  public openHelpUrl(url: string): void
  {
      window.open(url);
  }
}
